<div class="container" [ngSwitch]="mode">
    <div *ngSwitchDefault>
      <div *ngIf="isLoading" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
      <table *ngIf="!isLoading" style="width:100%">
        <tr  class="back">
          <th>S/N</th>
          <th>Name</th>
          <th>
          </th>
          <!-- <th>Edit</th> -->
        </tr>
        <tr class="td" *ngFor="let cartegory of cartegories">
          <td>{{cartegory.id}}</td>
          <td>{{cartegory.name}}</td>
          <td>{{cartegory.Status}}</td>
          <!-- <td>
            <button mat-icon-button color="primary" (click)="edit()">
              <mat-icon>edit</mat-icon>
            </button>
          </td> -->
        </tr>
      </table>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <!-- <div class="last">
        <button class="add" mat-raised-button color="primary" (click)="addNew()">
          Add New
        </button>
      </div> -->
    </div>

    <!-- <div class="post" *ngSwitchCase="'add'">
      <div class="post">
        <div class="title">Create Cartegory</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput placeholder="Employee">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Status</mat-label>
                <select matNativeControl required>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </mat-form-field>
        </span>
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            Create
          </button>
        </div>
      </div>
    </div>
    <div class="post" *ngSwitchCase="'edit'">
      <div class="post">
        <div class="title">Edit Cartegory</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput placeholder="Employee">
              </mat-form-field>
          </span>
          <span class="input">
            <mat-form-field>
                <mat-label>Status</mat-label>
                <select matNativeControl required>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </mat-form-field>
        </span>
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            Edit
          </button>
        </div>
      </div>
    </div> -->
    
    
  </div>